'use strict';

import toastr from 'toastr';

toastr.options = {
    "closeButton": true,
    "preventDuplicates": true,
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "300000",
};

window.toastr = toastr;

